import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { Title } from 'ziphy-web-shared/basic/lib/simple';
import { $notes } from '../../Notes.store';
import Blocks from '../../section/blocks/Blocks';
import BlocksPlain from '../../section/blocksPlain/BlocksPlain';
import MacrosPlus from '../../ui/macrosPlus/MacrosPlus';
import sectionStyles from '../Section.module.scss';
const SectionBase = ({ $section, hasError }) => {
    return (_jsx("div", Object.assign({ id: `ref_${$section.id}`, className: classNames(sectionStyles.wrapper, hasError && sectionStyles.error) }, { children: _jsxs("div", Object.assign({ className: sectionStyles.body }, { children: [_jsxs("div", Object.assign({ className: sectionStyles.title }, { children: [_jsx(Title, Object.assign({ size: 'h2' }, { children: $section.title })), $notes.isPlain ? null : (_jsx(MacrosPlus, { "$section": $section, macrosList: $section.macros.plus }))] })), $notes.isPlain ? (_jsx(BlocksPlain, { "$section": $section, className: sectionStyles.blocks })) : (_jsx(Blocks, { "$section": $section, className: sectionStyles.blocks }))] })) })));
};
export default observer(SectionBase);
